import { environment } from "./util.environment.js";
import { makeEnvironmentRef } from "./util.make-environment-ref.js";
import { z } from "zod";
//#region src/env/parser.string.ts
var defaultSchema = z.string();
/**
* extract string value directly from an environment variable
*/
function asString(key, options) {
	return makeEnvironmentRef(() => {
		var _options$schema;
		return ((options === null || options === void 0 ? void 0 : options.schema) ?? defaultSchema).parse(environment.read(key, { optional: options === null || options === void 0 || (_options$schema = options.schema) === null || _options$schema === void 0 ? void 0 : _options$schema.safeParse(void 0).success }));
	});
}
//#endregion
export { asString };

//# sourceMappingURL=parser.string.js.map